<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div>
                    <vx-label :id="franchiseHubLabelId" size="md">Franchise Hub</vx-label>
                    <div :id="franchiseHubNoteId" class="text-sm text-slate-700">
                        Franchise Hub can't be turned off once enabled.
                    </div>
                </div>

                <div>
                    <vx-radio-selection
                        v-model="franchiseHub"
                        size="sm"
                        :aria-labelledby="franchiseHubLabelId"
                        :aria-describedby="franchiseHubNoteId"
                        :error="error"
                    >
                        <vx-radio-selection-item value="none">No Franchise Hub</vx-radio-selection-item>
                        <vx-radio-selection-item :value="GROUP_STATUS_ACTIVE">
                            Franchise Hub, new groups start as Active
                        </vx-radio-selection-item>
                        <vx-radio-selection-item :value="GROUP_STATUS_DRAFT">
                            Franchise Hub, new groups start as Draft
                        </vx-radio-selection-item>
                    </vx-radio-selection>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxLabel, VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { computed, ref, useId, watch } from 'vue';
import { GROUP_STATUS_ACTIVE, GROUP_STATUS_DRAFT } from '~/constants/groupStatuses';
import type { CreateTeamData } from '~/services/adminTeamsClient.types';
import { displayFirstError } from '~/utils/validation';

const form = defineModel<CreateTeamData>({ required: true });

const franchiseHub = ref<'none' | typeof GROUP_STATUS_ACTIVE | typeof GROUP_STATUS_DRAFT>();
const franchiseHubLabelId = useId();
const franchiseHubNoteId = useId();

watch(franchiseHub, (choice) => {
    form.value.contact_groups = choice !== 'none';
    form.value.default_group_status = choice === 'none' ? undefined : choice;
});

const validate = useVuelidate(
    {
        franchise_hub: {
            required: required,
        },
    },
    computed(() => ({
        franchise_hub: franchiseHub.value,
    }))
);

const error = computed(() => displayFirstError(validate.value.franchise_hub.$errors));
</script>
